import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { LOGIN } from '../shared/urls';
import { SharedService } from '../shared/shared.service';
export class User {
  id_token: string;
}
@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  constructor(
    private http: HttpClient,
    private sharedService: SharedService,
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(sessionStorage.getItem('currentUser')),
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(username: string, password: string) {
    let url = LOGIN.TOKEN;
    const obj = {
      username: username,
      password: password,
      rememberMe: true,
    };
    return this.sharedService.commonPostHandler(url, obj).pipe(
      map((user) => {
        if (user) {
          sessionStorage.setItem('sso_token', user.token);
          this.currentUserSubject.next(user);
        }

        return user;
      }),
    );
  }

  logout() {
    sessionStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);
  }
}
